import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import Modal from '../../../../components/common/Modal';
import { ruppesSymbol } from '../../../../refresh/pages/CartPage/Constants';
import {
  getAjioWalletEligibleAmount,
  getAjioWalletStatusCode,
  getThresholdValue
} from '../../../../refresh/selectors/ajioWalletData';
import {
  getDeliveryChargeValue,
  getGstChargeValue,
  getMembershipBenefitList,
  getOrderTotalValue
} from '../../../../refresh/selectors/cartSelector';
import { gtmEventPush } from '../../../../modules/ga/GTMdatalayer';
import { getAjioMemberShipConfig, getEnableAjioMemberShipProgram } from '../../../../refresh/selectors/featureFlagsSelector';

const AjioSuperCashModal = props => {
  const { hideModal, ajioSuperCashCurrencyConfig, ajioSuperCashCartConfig } = props;
  const { currencyName = '' } = ajioSuperCashCurrencyConfig || {};
  const { halfCardCta = '', halfCardDescription = '', tAndCLink = ''} =
    ajioSuperCashCartConfig || {};

  const handleCloseModal = () => hideModal('ajio-supercash');

  return (
    <Modal name="ajio-supercash" className="ajio_supercash" closeButton ariaLabel="Supercash">
      <div className="container">
        <div className="header">
          <p role='heading' aria-level={2}>{currencyName}</p>
          <button
            className="tAndC"
            role="link"
            onClick={() => {
              window.location.href = tAndCLink;
            }}
          >
            {halfCardCta}
          </button>
        </div>
        <div className="content">{halfCardDescription}</div>
        <button type="button" onClick={handleCloseModal}>
          Okay
        </button>
      </div>
    </Modal>
  );
};

const AjioSuperCash = props => {
  const {
    showModal,
    hideModal,
    ajioSuperCashCartConfig,
    ajioSuperCashCurrencyConfig,
    statusCode,
    thresholdValue,
    orderTotalValue,
    deliveryChargeValue,
    gstChargeValue,
    eligibleEarnAmount,
    ajioWalletData = {},
    membershipMasterFlag,
    membershipBenefitList = {}
  } = props;
  const { currencyPrimaryLogo = '', currencyName = '' } = ajioSuperCashCurrencyConfig || {};
  const { superCashTitle = '', superCashSubtitle = '', stripCta = '', subscriptionXsuperCashTitle = '', subscriptionXsuperCashSubtitle = '' } =
    ajioSuperCashCartConfig || {};
  const { ajioWalletBalanceDet = {} } = ajioWalletData || {};
  const { totalWalletBalance = {} } = ajioWalletBalanceDet || {};
  const { totalCash = '0', totalPoints = '0' } = totalWalletBalance || {};

  console.log("🚀 ~ membershipBenefitList:", membershipBenefitList)

  const hasSuperCashBenefitInSubscription = membershipBenefitList?.includes('super_cash_benefit')
  let superCashTitleWithValue = membershipMasterFlag && hasSuperCashBenefitInSubscription ? subscriptionXsuperCashTitle : superCashTitle;

  // NOTE: CONDITIONS TO DECIDE WHETHER TO SHOW THIS COMPONENT OR NOT
  if (isNaN(thresholdValue) || !statusCode) return null;

  const pointValue = thresholdValue - (orderTotalValue - deliveryChargeValue - gstChargeValue);

  if (pointValue > 0 || !pointValue) return null;

  if (eligibleEarnAmount <= 0) return null;

  if (eligibleEarnAmount > 0) {
    superCashTitleWithValue = superCashTitleWithValue.replace(
      '{super_cash}',
      `${ruppesSymbol}${eligibleEarnAmount}`
    );
  }

  const handleOpenModal = () => {
    gtmEventPush({
      event: 'buttonTap',
      event_category: 'bag interactions',
      event_action: 'ajio supercash',
      event_label: 'know more',
      supercash_earn: eligibleEarnAmount,
      supercash_balance: totalPoints,
      ajio_cash_balance: totalCash
    });

    showModal('ajio-supercash');
  };

  useEffect(() => {
    gtmEventPush({
      event: 'bag_interaction',
      event_category: 'bag interactions',
      event_label: 'wallet_viewed',
      supercash_earn: eligibleEarnAmount,
      supercash_balance: totalPoints,
      ajio_cash_balance: totalCash
    });
  }, []);

  return (
    <>
      <div className="ajio_supercash-container">
        <div className="icon">
          <img src={currencyPrimaryLogo} alt={superCashTitle} aria-hidden="true"/>
        </div>
        <div className="content">
          <p className="title">{superCashTitleWithValue}</p>
          <p className="description">{membershipMasterFlag && hasSuperCashBenefitInSubscription ? subscriptionXsuperCashSubtitle : superCashSubtitle}</p>
          <button type="button" onClick={handleOpenModal} tabIndex={0} aria-label="Know more about Supercash amount">
            {stripCta}
          </button>
        </div>
      </div>
      <AjioSuperCashModal
        ajioSuperCashCurrencyConfig={ajioSuperCashCurrencyConfig}
        ajioSuperCashCartConfig={ajioSuperCashCartConfig}
        hideModal={hideModal}
      />
    </>
  );
};

const mapStateToProps = state => ({
  statusCode: getAjioWalletStatusCode(state),
  thresholdValue: getThresholdValue(state),
  orderTotalValue: getOrderTotalValue(state),
  deliveryChargeValue: getDeliveryChargeValue(state),
  gstChargeValue: getGstChargeValue(state),
  eligibleEarnAmount: getAjioWalletEligibleAmount(state),
  ajioWalletData: state?.ajioWalletData || {},
  membershipBenefitList: getMembershipBenefitList(state),
  membershipMasterFlag:
    (getEnableAjioMemberShipProgram(state?.flags, state) || false) &&
    getAjioMemberShipConfig(state?.flags, state)?.isEnableForCart
});
const connector = connect(mapStateToProps);
export default connector(AjioSuperCash);
